import { SelectableOption } from "./selectable-option";

export default SelectableOption;
